export default {"src":"/_next/static/media/GooglePlay.a5b4bc35.svg","height":76,"width":197};